<div
  [@zoomIn]
  class="row relative cursor-pointer hover:bg-parrot-50 border border-gray-300 hover:border-primary-500 rounded-lg flex items-center justify-between w-full px-4 py-3">
  <!-- <app-progress-bar
    *ngIf="progress"
    class="h-1 absolute w-full"
    [total]="progress.total"
    [progress]="progress.current"
  ></app-progress-bar> -->

  <ng-container *ngFor="let action of rows">
    <div class="col flex">
      <ng-container *ngTemplateOutlet="action.content"> </ng-container>
    </div>
  </ng-container>
</div>
